import React from 'react';
import { Card, CardMedia, CardContent, Typography, Grid, Avatar, Box } from '@mui/material';
import AlwaysOnBoolingIcon from '../BookingIcon/AlwaysOnBookingIcon';

import { Helmet } from 'react-helmet';
import StructuredData from '../StructuredData';
const cardData = [
  {
    img: '/images/salem-to-yercaud.jpeg',
    city: 'Yercaud',
    distance: '65Kms',
    time: '3hr',
    miniFare: '1249',
    sedanFare: '1349',
    discription:'salem to yercaud taxi & cab service',
    title:'cheapast taxi & cab service in salem to yercaud'
  },
  {
    img: '/images/salem-to-mettur-dam.jpeg',
    city: 'Mettur Dam',
    distance: '120Kms',
    time: '4hr',
    miniFare: '1349',
    sedanFare: '1449',
    description:'salem to mettur dam taxi & cab service',
    title:'cheapast taxi & cab service in salem to mettur dam'
  },
  {
    img: '/images/salem-to-bangalore.jpeg',
    city: 'Bangalore',
    distance: '65Kms',
    time: '3hr',
    miniFare: '1249',
    sedanFare: '1349',
    description:'salem to bangalore taxi & cab service',
     title:'cheapast taxi & cab service in salem to bangalore'
  },
  {
    img: '/images/salem-to-coimbatore.jpeg',
    city: 'Coimbatore',
    distance: '120Kms',
    time: '4hr',
    miniFare: '1349',
    sedanFare: '1449',
    description:'salem to coimbatore taxi & cab service',
 title:'cheapast taxi & cab service in salem to coimbatore'
  },
  {
    img: '/images/salem-to-kanyakumari.jpeg',
    city: 'Kanyakumari',
    distance: '65Kms',
    time: '3hr',
    miniFare: '1249',
    sedanFare: '1349',
    description:'salem to kanyakumari taxi & cab service',
     title:'cheapast taxi & cab service in salem to kanyakumari'

  },
  {
    img: '/images/salem-to-kodaikanal.jpeg',
    city: 'Kodaikanal',
    distance: '120Kms',
    time: '4hr',
    miniFare: '1349',
    sedanFare: '1449',
     description:'salem to kodaikanal taxi & cab service',
      title:'cheapast taxi & cab service in salem to kodaikanal'
  },
  {
    img: '/images/salem-to-thirupathi.jpeg',
    city: 'Thirupathi',
    distance: '120Kms',
    time: '4hr',
    miniFare: '1349',
    sedanFare: '1449',
     description:'salem to thirupathi taxi & cab service',
      title:'cheapast taxi & cab service in salem to thirupathi'
  },
  {
    img: '/images/salem-to-ooty.jpeg',
    city: 'Ooty',
    distance: '65Kms',
    time: '3hr',
    miniFare: '1249',
    sedanFare: '1349',
     description:'salem to ooty taxi & cab service',
      title:'cheapast taxi & cab service in salem to ooty'
  },
  {
    img: '/images/salem-to-oganakkal.jpeg',
    city: 'Oganakkal',
    distance: '120Kms',
    time: '4hr',
    miniFare: '1349',
    sedanFare: '1449',
     description:'salem to oganakkal taxi & cab service',
      title:'cheapast taxi & cab service in salem to oganakkal'
  },
  // Add more data as per the provided list
];

const PackagesPage = () => {
  return (
    <>
    <StructuredData /> 
    <Box>
       <Helmet>
    <meta charset="UTF-8" />
 <meta name="viewport" content="width=device-width, initial-scale=1.0" />
 <meta property="og:type" content="website" />
 <meta property="og:site_name" content="SVR Taxi Service | Call us 9965821750" />
 <meta charset="UTF-8" />
 
 <meta property="og:locale" content="en_IN" />
        <meta property="og:url" content="https://svrtaxi.netlify.app/package"/>
        <meta property="og:image" content="https://svrtaxi.netlify.app/VisitingCard.jpg" />
 <meta name="description" content="Reliable, taxi, service, in Salem, and, across India. Available 24/7 with professional drivers and affordable pricing. Book now for a comfortable journey."/>
 <meta name="keywords" content="best cab service in salem ,Salem to Yercaud Taxi Service - Affordable Rides to the Scenic Hill Station,Salem to Tirupati Taxi - Comfortable Rides to the Sacred Temple Town, Salem to Bangalore Taxi Service - Fast and Reliable City Transfers,Salem to Madurai Taxi Service - Explore the Historic City with Ease,Salem to Coimbatore Taxi Service - Quick and Safe Transportation,
Salem to Ooty Taxi Service - Scenic Rides to the Queen of Hill Stations, Salem to Kodaikanal Taxi Service - Travel to the Princess of Hill Stations , Salem to Kanyakumari Taxi Service - Journey to the Southern Tip of India , Salem to Chennai Taxi Service - Efficient Transfers to Tamil Nadu’s Capital , Salem to Oganakkal Falls Taxi Service - Explore the Stunning Waterfalls , Salem to Mettur Dam Taxi Service - Comfortable Rides to the Historic Dam , Salem to Thanjavur Taxi Service - Explore the Cultural Capital of Tamil Nadu ,taxi ,service, Salem, India, airport, transfers, intercity, travel, taxi ,booking,svr taxi,Affordable, taxi ,service ,from ,Salem, to ,Chennai,Best, outstation, cab ,service, from ,Salem ,to ,Kodaikanal,Taxi ,service ,for ,day, trips, in ,and, around, Salem,One-way ,taxi ,service ,from ,Salem ,to ,Bangalore,Book ,a, cab, for ,Salem to ,Tiruchirappalli ,trip,Salem to ,Yercaud ,cab ,service for ,family ,trips,Reliable ,24-hour, taxi, service in Salem,Taxi booking, for airport transfers, in Salem,Safe, taxi, service ,for solo ,women, travelers ,in Salem,Outstation, cab, services ,from Salem ,for business ,trips,Affordable car ,rental ,for Salem, sightseeing,Affordable ,Salem to ,Ooty, weekend, tour ,packages,Salem to ,Munnar, taxi, service with sightseeing packages,Pilgrimage, taxi service from, Salem to ,Samayapuram, Temple,
    Budget ,taxi, packages, from Salm to ,Hogenakkal, Falls,Cab service for Salem to ,Kodaikanal, honeymoon, package,Luxury, taxi service, for ,corporate ,trips, from Salem to ,Chennai,Round-trip, taxi ,service ,from Salem to, Mysore,Car, rental, with, driver, for ,outstation trips, in ,Tamil Nadu,Customized, tour packages, with taxi service in Tamil Nadu,
    Cheap, cab ,service for ,outstation trips, from Salem, best, taxi service in salem , best , taxi , service , Best taxi service in salem , Best Cab service in salem"/>
 <meta name="author" content="Call to Book 9965821750" />
 <link rel="canonical" href="https://svrtaxi.netlify.app/package" />
{/* {    <link rel="icon" href="%PUBLIC_URL%/favicon.ico" type="image/x-icon" /> } */}

 <meta property="og:title" content="Cab/Taxi Service in Salem | 11 Rs. per km cheapast taxi service" />
 <meta property="og:description" content="Providing safe, reliable, and affordable taxi services in Salem and across India. Book now for a hassle-free experience."/>
 
 <link rel="stylesheet" href="%PUBLIC_URL%/styles.css"/>
 <link rel="preconnect" href="https://fonts.googleapis.com"/>
 <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
 <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet" />
   <title>Cab/Taxi Service in Salem | Call us +91 9965821750 </title>
 
 </Helmet>
    <Box sx={{ flexGrow: 1, padding: '20px' }}>
              <AlwaysOnBoolingIcon/>
        <Typography variant="h3" gutterBottom>
          Packages
        </Typography>
        <Typography variant='h1' component="h1" sx={{fontSize:'20px'}}>Taxi Service in salem | Cheapast Taxi service | 11 Rs Per kilometer</Typography>
        <br/>
      <Grid container spacing={4}>
        {cardData.map((card, index) => (
          <Grid item xs={12} md={6} lg={4} key={index}>
            <Card sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
              <CardMedia
                component="img"
                sx={{ width: '50%',height:'100%' }}
                title={card.title}
                image={card.img}
                alt={card.description}
              />
              <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                <CardContent>
                  <Typography component="h1" variant="h1" sx={{fontSize:'larger' }}>
                    Salem to {card.city} 
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary" component="div">
                    {card.distance} | {card.time}
                  </Typography>
                </CardContent>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
      
    </Box>
    </Box>
    </>  );
};

export default PackagesPage;
